import React from 'react'

const Footer = () => {
    return (
        <div>
            {/* /.content-wrapper */}
            <footer className="main-footer">
                <strong>Copyright © 2025 <a href="#">Academia</a>.</strong>
                All rights reserved.
                <div className="float-right d-none d-sm-inline-block">
                    <b>Version</b> 1.0.0
                </div>
            </footer>
        </div>
    )
}

export default Footer